import { createFileRoute, redirect } from '@tanstack/react-router';

/** Old address of the engine status. */
export const Route = createFileRoute('/_app/system')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/status', replace: true });
  },
});
